export interface BatchReserveUserListRequest {
  dateFrom: string
  dateTo: string
  dateType: string
  branchCode: string
  branchType: string
  reserveStatus: string
  outputOrder: string
  hasLendable: boolean
  lendableNumber: Number | null
  lendableType: string
  reserveMethod: string
  reserveContactMethod: string
  materialFormatFrom: string
  materialFormatTo: string
  batchType: string
}

export function BatchReserveUserListRequestToJSON(
  value: BatchReserveUserListRequest
): any {
  return {
    date_from: value.dateFrom,
    date_to: value.dateTo,
    date_type: value.dateType,
    branch_code: value.branchCode,
    branch_type: value.branchType,
    reserve_status: value.reserveStatus,
    output_order: value.outputOrder,
    has_lendable: value.hasLendable,
    lendable_number: value.lendableNumber,
    lendable_type: value.lendableType,
    reserve_method: value.reserveMethod,
    reserve_contact_method: value.reserveContactMethod,
    material_format_from: value.materialFormatFrom,
    material_format_to: value.materialFormatTo,
    batch_type: value.batchType
  }
}
